import axios from 'axios';
import Cookies from 'js-cookie';
import { useMutation, useQueryClient } from 'react-query';
import { getAddress } from 'viem';
import { useSignTypedData } from 'wagmi';

// import { useGetCurrentToken } from '~/hooks/auth/useGetCurrentToken';
// import { useGetAccount } from '~/hooks/web3/useGetAccount';
import { gameCookieName } from '~/utils/utils';

const apiHost = process.env.NEXT_PUBLIC_API_HOST;

export const useFetchAccessToken = ({ walletAddress }: {walletAddress: string}) => {
  const { signTypedDataAsync } = useSignTypedData();
  const queryClient = useQueryClient();
  return useMutation<any, Error>(['token', walletAddress], async () => {
    // if (accessToken) return accessToken;
    const checkSumAddress = getAddress(walletAddress).toLowerCase();
    // fetch new token
    const formDataAuth = new FormData();
    formDataAuth.append('signing_address', checkSumAddress);
    const { data } = await axios({
      url: `${apiHost}/auth/authorize`,
      method: 'post',
      data: formDataAuth,
    });
    const payload = JSON.stringify(data);
    const preparedData = {
      domain: data?.domain || '',
      message: data?.message || '',
      types: { Authorization: data?.types?.Authorization || '' },
      primaryType: 'Authorization' as 'Authorization',
    };

    // prompt user for signature and wait until signed
    const signature = await signTypedDataAsync(preparedData);

    const formDataToken = new FormData();
    formDataToken.append('signature', signature);
    formDataToken.append('message', payload);
    const {
      data: { token },
    } = await axios({
      url: `${apiHost}/auth/token`,
      method: 'post',
      data: formDataToken,
    });
    const name = gameCookieName(walletAddress);
    Cookies.set(name, token);
    queryClient.invalidateQueries();

    return token;
  });
};
